/* Tiroir panier : ouverture sur le côté après l'ajout (y compris via Kaching), suppression d'une ligne,
   date de livraison estimée. Chargé après theme.js. */
(() => {
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  const drawer = () => document.getElementById('CartDrawer');
  const autoOpen = () => document.body.dataset.autoOpenCart === 'true';

  /* Date de livraison estimée en jours ouvrés (lundi-vendredi) */
  const addBusinessDays = (n) => {
    const d = new Date();
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      const w = d.getDay();
      if (w !== 0 && w !== 6) n -= 1;
    }
    return d;
  };
  const day = (d) => (d.getDate() === 1 ? '1er' : String(d.getDate()));
  const fmt = (d) => `${day(d)} ${d.toLocaleDateString('fr-FR', { month: 'short' })}`;
  const initDrawer = () => {
    document.querySelectorAll('[data-cd-eta]').forEach((el) => {
      const text = el.dataset.text || '';
      const a = addBusinessDays(Number(el.dataset.min) || 0);
      const b = addBusinessDays(Number(el.dataset.max) || 0);
      const sameMonth = a.getMonth() === b.getMonth();
      el.textContent = text.replace('[min]', sameMonth ? day(a) : fmt(a)).replace('[max]', fmt(b));
    });
  };

  const setCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  };

  const refresh = async () => {
    const res = await nativeFetch(`${root()}?section_id=cart-drawer`, { credentials: 'same-origin' });
    if (!res.ok) return;
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const fresh = doc.getElementById('CartDrawer');
    const current = drawer();
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    const countEl = doc.querySelector('[data-cart-count]');
    if (countEl) setCount(countEl.textContent.trim());
    initDrawer();
  };

  const open = () => {
    const d = drawer();
    if (d && typeof d.showModal === 'function' && !d.open) d.showModal();
  };

  let timer;
  let pendingOpen = false;
  const refreshSoon = (andOpen) => {
    pendingOpen = pendingOpen || andOpen;
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const shouldOpen = pendingOpen;
      pendingOpen = false;
      try {
        await refresh();
      } catch (err) {}
      if (shouldOpen && autoOpen()) open();
    }, 120);
  };

  /* Ajout au panier depuis la fiche produit (bouton du thème, bouton collant, widget Kaching dans le formulaire).
     theme.js laisse passer l'envoi quand Kaching est présent : on l'envoie ici en AJAX, avec tous les champs
     injectés par Kaching, au lieu de laisser la page partir vers /cart. */
  const isProductForm = (form) =>
    form.dataset.productForm === 'true' ||
    form.dataset.ajax === 'cart' ||
    (form.getAttribute('action') || '').includes('/cart/add');

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || e.defaultPrevented) return;
    if (!isProductForm(form) || form.dataset.skipAjax === 'true' || !autoOpen() || !drawer()) return;
    e.preventDefault();
    const formData = new FormData(form);
    if (!formData.get('quantity') && !formData.has('items[0][id]')) formData.set('quantity', '1');
    const btn = form.querySelector('[data-add]');
    if (btn) btn.disabled = true;
    try {
      const res = await nativeFetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      if (!res.ok) throw new Error('add');
      await refresh();
      open();
    } catch (err) {
      HTMLFormElement.prototype.submit.call(form);
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  /* Si une app ajoute ou modifie le panier elle-même (fetch ou XHR), on met le tiroir à jour et on l'ouvre après un ajout */
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  const isAdd = (url) => /\/cart\/add/.test(url);
  window.fetch = function (input, init) {
    const p = nativeFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || String(input);
      if (CART_RE.test(url)) {
        p.then((r) => {
          if (r && r.ok) refreshSoon(isAdd(url));
        }).catch(() => {});
      }
    } catch (err) {}
    return p;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cdUrl = String(url || '');
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    const url = this.__cdUrl || '';
    if (CART_RE.test(url)) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) refreshSoon(isAdd(url));
      });
    }
    return xhrSend.apply(this, arguments);
  };

  /* Supprimer une ligne, fermer le tiroir (boutons recréés à chaque mise à jour) */
  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-cd-remove]');
    if (rm) {
      e.preventDefault();
      const line = rm.closest('.cd-line');
      if (line) line.classList.add('is-loading');
      try {
        await nativeFetch(`${root()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: rm.dataset.cdRemove, quantity: 0 }),
        });
      } catch (err) {}
      try {
        await refresh();
      } catch (err) {}
      if (document.querySelector('[data-cart-page]')) window.location.reload();
      return;
    }
    const closeBtn = e.target.closest('#CartDrawer [data-close]');
    if (closeBtn) {
      const d = drawer();
      if (d && d.open) d.close();
    }
  });

  /* Mise à jour faite par theme.js : recalculer la date */
  const d0 = drawer();
  if (d0) new MutationObserver(initDrawer).observe(d0, { childList: true });
  initDrawer();
})();
